import React from "react"
import styled from '@emotion/styled'
import PropTypes from "prop-types"

function Img (props) {
    const {alt,src, style, className, isReact} = props
    const Img = styled.img`
        width: '100%',
        height: 'auto',
        display: 'block'
    `
    const media_url = process.env.REACT_APP_MEDIA_URL
    const embedded_url = process.env.REACT_APP_EMBEDDED_MEDIA

    const srcUrl = (isReact) ? `${embedded_url}${src}` :`${media_url}${src}`

    return(
        <Img alt={alt} loading='lazy' src={srcUrl} style={style} className={className} />
    )

}

Img.propTypes = {
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    style: PropTypes.object
}



export default Img